export default "__VITE_ASSET__B0l2CU0X__"